<div class="popup-content waybill-complete-popup">
  <div class="popup-header">
    <div class="d-flex">
      <h2 class="popup-title">
        <i class="fas fa-ban me-2"></i>
        Gestione Colli nei Borderò
      </h2>
    </div>

    <div>
      <button type="button" class="btn-close" (click)="close()">
        <i class="fas fa-times"></i>
      </button>
    </div>
  </div>

  <div class="popup-body" [class.step-1]="step === 1" [class.step-2]="step === 2">
    <div *ngIf="step === 1">
      <form [formGroup]="form">
        <div class="mb-4">
          <h5 class="section-title">
            <i class="fas fa-warehouse me-2"></i>
            Magazzino
          </h5>

          <div class="row g-3">
            <div class="col-md-8">
              <select class="form-select custom-select"
                      formControlName="warehouseCode"
                      [disabled]="(data.warehouses?.length || 0) === 1">
                <option [ngValue]="null">Seleziona magazzino</option>
                <option *ngFor="let w of data.warehouses" [ngValue]="w.warehouseCode">
                  {{ w.warehouseName || '' }}
                </option>
              </select>

              <div *ngIf="form.get('warehouseCode')?.touched && form.get('warehouseCode')?.invalid"
                   class="invalid-feedback d-block">
                Seleziona un magazzino
              </div>
            </div>

            <!-- <div class="col-md-4" *ngIf="isExtraVisible">
              <div class="extra-switch-wrap">
                <span class="extra-label" [class.on]="form.get('extra')?.value">
                  {{ form.get('extra')?.value ? 'Extra attivo' : 'Extra disattivo' }}
                </span>

                <label class="switch">
                  <input type="checkbox" formControlName="extra">
                  <span class="slider"></span>
                </label>
              </div>
            </div> -->
          </div>
        </div>

        <div class="mb-4">
          <h5 class="section-title">
            <i class="fas fa-route me-2"></i>
            Tour routing group
          </h5>

          <div formArrayName="tourGroupIds" class="tour-groups-list">
            <div class="tour-group-row" *ngFor="let ctrl of tourGroupIdsArray.controls; let i = index">
              <div class="tour-row-layout">
                <div class="tour-index">{{ i + 1 }}</div>

                <div class="tour-select-wrap">
                  <select class="form-select custom-select"
                          [disabled]="!form.get('warehouseCode')?.value"
                          [class.is-invalid]="ctrl.touched && ctrl.invalid"
                          [formControlName]="i"
                          (change)="onTourGroupChanged()">
                    <option [ngValue]="null">Seleziona tour group</option>
                    <option *ngFor="let tg of getAvailableTourGroupsForIndex(i)"
                            [ngValue]="tg.tourRoutingGroupId">
                      {{ tg.tourRoutingGroupName }}
                    </option>
                  </select>
                </div>

                <div class="tour-actions">
                  <button type="button"
                          class="btn btn-outline-primary btn-icon"
                          (click)="addTourGroup()"
                          [disabled]="!canAddMoreTours(i)">
                    <i class="fas fa-plus"></i>
                  </button>

                  <button type="button"
                          class="btn btn-outline-danger btn-icon"
                          (click)="removeTourGroup(i)"
                          [disabled]="tourGroupIdsArray.length === 1">
                    <i class="fas fa-minus"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </form>
    </div>

    <div *ngIf="step === 2" class="items-step-wrap" [class.is-loading]="loadingItemsSpinner">
      <div class="popup-header-tabs mb-3">
        <div class="statistics-toggle-group w-100">
          <button type="button"
                  class="statistics-toggle-btn danger-tab"
                  [class.active-danger]="selectedTab === 'invalidate'"
                  (click)="setTab('invalidate')">
            <i class="fas fa-ban"></i>
            INVALIDA
          </button>

          <button type="button"
                  class="statistics-toggle-btn success-tab"
                  [class.active-success]="selectedTab === 'validate'"
                  (click)="setTab('validate')">
            <i class="fas fa-undo"></i>
            RIVALIDA
          </button>
        </div>
      </div>

      <div class="items-summary-card">
        <div class="summary-title">
          <i class="fas fa-list-check me-2"></i>
          <b class="me-2">Colli</b>
          <span class="badge items-counter-badge me-2">
            {{ selectedCount }}/{{ totalCount }}
          </span>
        </div>

        <div class="summary-sub text-muted">
          <span class="summary-item"
                  [matTooltip]="'Tour: ' + (selectedTourGroupNames || '-' )"
                  matTooltipPosition="above">
              Tour: <b class="ellipsis">{{ selectedTourGroupNames || '-' }}</b>
            </span>

            <span class="ms-2 me-2 dot">•</span>

            <span class="summary-item"
                  [matTooltip]="'Magazzino: ' + (warehouseName || '-')"
                  matTooltipPosition="above">
              Magazzino: <b class="ellipsis">{{ warehouseName || '-' }}</b>
            </span>
        </div>

        <div class="summary-actions d-flex align-items-center justify-content-between gap-2 mt-2">
          <div class="d-flex gap-2">
            <button type="button" class="btn btn-outline-primary bt-small" (click)="selectAll()">
              <i class="fas fa-check-double me-2"></i>Seleziona tutto
            </button>

            <button type="button" class="btn btn-outline-secondary bt-small" (click)="deselectAll()">
              <i class="fas fa-ban me-2"></i>Deseleziona tutto
            </button>
          </div>

          <div class="d-flex align-items-center">
            <div class="filter-group urgency-filter"
                style="align-content: center; padding-right:10px;"
                (click)="toggleUrgencyFilter()">

              <span class="urgency-badge-filter"
                    [class.active]="onlyUrgent"
                    [class.inactive]="!onlyUrgent"
                    matTooltip="Filtra solo colli urgenti">
                <span class="urgency-label">URGENTE</span>
              </span>
            </div>
            <div class="barcode-search ms-auto">
              <i class="fas fa-search search-ico"></i>

              <input type="text"
                    class="form-control barcode-input"
                    placeholder="Cerca per barcode..."
                    [ngModel]="barcodeFilter"
                    (ngModelChange)="onBarcodeFilterChange($event)"
                    [disabled]="loadingItems || !validItems?.length">

              <button type="button"
                      class="btn btn-link clear-btn"
                      (click)="clearBarcodeFilter()"
                      [disabled]="!barcodeFilter">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="items-list-scroll mt-2">
  <div class="items-list">
    <div class="item-row"
         *ngFor="let it of visibleItems"
         [class.selected]="it.selected"
         (click)="toggleItem(it)">

      <div class="item-check">
        <input type="checkbox"
               class="form-check-input"
               [checked]="it.selected"
               (click)="$event.stopPropagation(); toggleItem(it)">
      </div>

      <div class="item-main d-flex justify-content-between w-100">
        <div class="item-left w-100">

          <div class="item-top-row d-flex align-items-center">
            <div class="item-title" style="width:190px;">
              <span class="parcel-code">
                {{ it.barcode || it.parcelCode || '-' }}
              </span>
            </div>

            <div class="item-sub text-muted ms-2 d-flex align-items-center gap-2">
              <div style="width:250px;">
                Peso: <b>{{ it.weightKgNum | number:'1.0-2' }} kg</b>
                <span>•</span>
                Volume: <b>{{ it.volumeM3Num | number:'1.0-3' }} m³</b>
              </div>

              <span class=" ms-3" style="width:100px;">
                {{ it.tourRoutingGroupName || '-' }}
              </span>

              <span class=" ms-3">
                {{ it.parcelPalletType || '-' }}
              </span>
            </div>
          </div>

          <div class="item-extra-row text-muted">
            <span class="extra-info">
              <i class="fas fa-calendar-alt me-1"></i>
              Affido:
              <b>{{ it.parcelDate ? (it.parcelDate | date:'dd/MM/yy HH:mm') : '-' }}</b>
            </span>

            <span class="extra-sep">•</span>

            <span class="extra-info">
              <i class="fas fa-clock me-1"></i>
              Consegna stimata:
              <b>{{ it.parcelEstimatedDeliveryDate ? (it.parcelEstimatedDeliveryDate | date:'dd/MM/yy HH:mm') : '-' }}</b>
            </span>

            <span class="extra-sep">•</span>

            <span class="extra-info">
              <i class="fas fa-map-marker-alt me-1"></i>
              Regione:
              <b>{{ it.regionAcronym || '-' }}</b>
            </span>

            <span class="extra-sep">•</span>

            <span class="extra-info">
              <i class="fas fa-user me-1"></i>
              Cliente:
              <b>{{ it.clientAcronym || '-' }}</b>
            </span>
          </div>

        </div>

        <div class="item-right justify-content-between d-flex align-items-center">
          <span *ngIf="it.urgencyCode"
                class="urgency-badge-item ms-2">
            <span class="urgency-label">URGENTE</span>
          </span>

          <span class="badge status-badge text-center"
                [class.invalidate-selected]="selectedTab === 'invalidate' && it.selected"
                [class.validate-selected]="selectedTab === 'validate' && it.selected"
                [class.neutral]="
                  (selectedTab === 'invalidate' && !it.selected) ||
                  (selectedTab === 'validate' && !it.selected)
                ">

            <i class="fas"
                [class.fa-undo]="
                 (selectedTab === 'validate' && it.selected)
               "
               [class.fa-check]="
                 (selectedTab === 'invalidate' && !it.selected)
               "
               [class.fa-ban]="
                 (selectedTab === 'invalidate' && it.selected) ||
                 (selectedTab === 'validate' && !it.selected)
               ">
            </i>

            {{
              selectedTab === 'invalidate'
                ? (it.selected ? 'INVALIDA' : 'VALIDO')
                : (it.selected ? 'RIVALIDA' : 'INVALIDO')
            }}
          </span>
        </div>

      </div>
    </div>

    <div *ngIf="!visibleItems.length" class="text-center text-muted py-4">
      Nessun collo disponibile nel tab selezionato
    </div>
  </div>
</div>
    </div>
  </div>

  <div class="popup-footer" *ngIf="step === 1">
    <div class="d-flex justify-content-end gap-2">
      <button type="button"
              class="btn btn-primary"
              (click)="goToItemsStep()"
              [disabled]="form.invalid || loadingCarriers || loadingItems">
        <i class="fas fa-arrow-right me-2"></i>
        Avanti
      </button>
    </div>
  </div>

  <div class="popup-footer" *ngIf="step === 2">
    <div class="d-flex justify-content-between gap-2">
      <button type="button" class="btn btn-secondary" (click)="backToForm()">
        <i class="fas fa-arrow-left me-2"></i>Indietro
      </button>

      <button type="button"
              [class]="selectedTab === 'invalidate' ? 'btn btn-danger' : 'btn btn-success-validate'"
              (click)="confirm()"
              [disabled]="selectedCount === 0 || submitting">
        <i class="fas me-2" [class.fa-ban]="selectedTab === 'invalidate'" [class.fa-undo]="selectedTab === 'validate'"></i>
        {{ selectedTab === 'invalidate' ? 'Invalida' : 'Rivalida' }} ({{ selectedCount }})
      </button>
    </div>
  </div>
</div>